<script lang="ts" setup>
    import { ref, watch } from 'vue'

    const props = defineProps({
        modelValue: {
            type: Object as () => { fromDate: string; toDate: string } | null,
            default: null,
        },
        label: {
            type: String,
            default: 'Date Range',
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    })

    const emit = defineEmits(['update:modelValue'])

    const date = ref<string[]>(props.modelValue ? [props.modelValue.fromDate, props.modelValue.toDate] : [])

    watch(
        () => props.modelValue,
        newVal => {
            const newArray = newVal ? [newVal.fromDate, newVal.toDate] : []
            if (JSON.stringify(newArray) !== JSON.stringify(date.value)) {
                date.value = newArray
            }
        },
        { deep: true },
    )

    watch(
        date,
        newVal => {
            if (!newVal || newVal.length !== 2) {
                if (props.modelValue !== null) {
                    emit('update:modelValue', null)
                }
            } else {
                const obj = { fromDate: newVal[0], toDate: newVal[1] }
                if (JSON.stringify(obj) !== JSON.stringify(props.modelValue)) {
                    emit('update:modelValue', obj)
                }
            }
        },
        { deep: true },
    )
</script>

<template>
    <el-form-item :label="$t('DateRange')" label-position="top">
        <el-date-picker
            :editable="false"
            v-model="date"
            class="w-100"
            type="daterange"
            format="DD-MM-YYYY"
            value-format="YYYY-MM-DD"
            placeholder="Pick a date"
            size="large"
        />
    </el-form-item>
</template>
